/*
 * Fabled Framing — Customer Showcase page
 * Builds endless drag/scroll marquee columns (rebuilt per breakpoint so
 * every photo is shown regardless of column count) + the lightbox.
 */
(function(){
  'use strict';

  var roots = document.querySelectorAll('.csw-root');
  if(!roots.length)return;

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var DRAG_THRESHOLD = 6;
  var RESUME_DELAY = 500;
  var DURATIONS=[68,82,60,90,72,76,64,88];
  var DIRECTIONS=['normal','reverse','normal','reverse','normal','reverse','normal','reverse'];

  roots.forEach(function(root){
    var gallery=root.querySelector('.csw-gallery');
    if(!gallery)return;

    var baseCols=parseInt(gallery.dataset.cols,10)||5;
    var baseGap=parseInt(gallery.dataset.gap,10)||10;
    var speed=parseFloat(gallery.dataset.speed)||1;
    var accent=gallery.dataset.accent;

    if(accent)gallery.style.setProperty('--acc',accent);
    gallery.style.setProperty('--spd',speed);

    /* The tiles Liquid rendered as flat, direct children of .csw-gallery —
       kept as permanent, never-inserted templates. Columns are built by
       cloning from this list, so it's safe to rebuild on every breakpoint
       change without ever losing or fighting over a node. */
    var sourceTiles=Array.prototype.slice.call(gallery.querySelectorAll(':scope > .csw-tile'));

    /* Testimonial blocks get their own scrolling marquee columns, built the
       same way as the photo columns below, but pinned to fixed column
       positions instead of being mixed in with the photos. The 2nd column
       (also the only testimonial column on mobile/tablet, which show fewer
       columns) gets one; the 4th column gets another when there's room and
       more than one testimonial to split across them. All testimonials are
       distributed round-robin across however many testimonial columns are
       showing at the current breakpoint. */
    var testimonialTiles=Array.prototype.slice.call(gallery.querySelectorAll(':scope > .csw-testimonial-tile'));

    var cols=[];
    var currentColCount=0;

    function testimonialSlots(n){
      if(!testimonialTiles.length)return[];
      var slots=[];
      if(n>=2)slots.push(1);
      if(n>=4&&testimonialTiles.length>1)slots.push(3);
      return slots;
    }

    function computeCols(){
      var w=window.innerWidth;
      if(w<=600)return Math.min(baseCols,2);
      if(w<=900)return Math.min(baseCols,3);
      return baseCols;
    }
    function computeGap(){
      var w=window.innerWidth;
      if(w<=600)return Math.min(baseGap,6);
      if(w<=900)return Math.min(baseGap,8);
      return baseGap;
    }

    function attachColumnInteractions(c){
      var el=c.el;

      el.addEventListener('pointerdown',function(e){
        if(e.pointerType==='mouse'&&e.button!==0)return;
        c.active=true;
        c.dragging=false;
        c.pointerId=e.pointerId;
        c.startY=e.clientY;
        c.startOffset=c.offset;
      });

      el.addEventListener('pointermove',function(e){
        if(!c.active||e.pointerId!==c.pointerId)return;
        var dy=e.clientY-c.startY;
        if(!c.dragging){
          if(Math.abs(dy)<DRAG_THRESHOLD)return;
          c.dragging=true;
          c.suppressClick=true;
          el.classList.add('is-dragging');
          try{el.setPointerCapture(c.pointerId)}catch(err){}
        }
        e.preventDefault();
        c.offset=c.startOffset-dy;
      });

      function endDrag(e){
        if(!c.active||e.pointerId!==c.pointerId)return;
        c.active=false;
        if(c.dragging){
          c.dragging=false;
          c.pausedUntil=performance.now()+RESUME_DELAY;
          el.classList.remove('is-dragging');
        }
      }
      el.addEventListener('pointerup',endDrag);
      el.addEventListener('pointercancel',endDrag);

      el.addEventListener('wheel',function(e){
        if(!c.height)return;
        e.preventDefault();
        c.offset+=e.deltaY;
        c.pausedUntil=performance.now()+RESUME_DELAY;
      },{passive:false});

      el.addEventListener('keydown',function(e){
        if(!c.height)return;
        var step=c.height*0.18;
        if(e.key==='ArrowDown'||e.key==='PageDown'){c.offset+=step;c.pausedUntil=performance.now()+RESUME_DELAY;e.preventDefault()}
        else if(e.key==='ArrowUp'||e.key==='PageUp'){c.offset-=step;c.pausedUntil=performance.now()+RESUME_DELAY;e.preventDefault()}
      });
    }

    function measure(){
      cols.forEach(function(c){
        c.height=(c.el.scrollHeight||0)/2;
      });
    }

    /* Builds one scrolling marquee column, cloning round-robin from `pool`
       (either the photo tiles or the testimonial tiles) at `poolPos` of
       `poolColCount` such columns sharing that pool. Shared by both photo
       and testimonial columns so testimonials scroll exactly like photos. */
    function buildMarqueeCol(c, pool, poolPos, poolColCount, extraClass, ariaLabel){
      var colEl=document.createElement('div');
      colEl.className=extraClass?('csw-col '+extraClass):'csw-col';
      colEl.tabIndex=0;
      colEl.setAttribute('aria-label',ariaLabel);
      colEl.dataset.duration=DURATIONS[c%DURATIONS.length];
      colEl.dataset.direction=DIRECTIONS[c%DIRECTIONS.length];

      var colLen=(pool.length&&poolColCount)?Math.max(4,Math.ceil(pool.length/poolColCount)):0;
      for(var pass=0;pass<2&&pool.length;pass++){
        for(var r=0;r<colLen;r++){
          var flatIdx=(r*poolColCount+poolPos)%pool.length;
          var node=pool[flatIdx].cloneNode(true);
          if(pass===1){
            node.setAttribute('aria-hidden','true');
            node.setAttribute('tabindex','-1');
            node.removeAttribute('aria-label');
          }
          colEl.appendChild(node);
        }
      }

      var state={
        el:colEl,
        dir:colEl.dataset.direction==='reverse'?-1:1,
        duration:parseFloat(colEl.dataset.duration)||70,
        height:0,
        offset:0,
        dragging:false,
        active:false,
        pointerId:null,
        startY:0,
        startOffset:0,
        pausedUntil:0,
        suppressClick:false
      };
      colEl._cswState=state;
      attachColumnInteractions(state);
      cols.push(state);
      return colEl;
    }

    function buildColumns(n){
      Array.prototype.slice.call(gallery.querySelectorAll('.csw-col')).forEach(function(el){el.remove()});
      cols=[];
      currentColCount=n;

      var tSlots=testimonialSlots(n);
      var photoColIdxs=[];
      for(var i=0;i<n;i++){
        if(tSlots.indexOf(i)===-1)photoColIdxs.push(i);
      }
      var m=photoColIdxs.length;

      var frag=document.createDocumentFragment();

      for(var c=0;c<n;c++){
        var tSlot=tSlots.indexOf(c);
        if(tSlot!==-1){
          frag.appendChild(buildMarqueeCol(c,testimonialTiles,tSlot,tSlots.length,'csw-col-testimonial','Scroll to browse customer testimonials'));
        }else{
          frag.appendChild(buildMarqueeCol(c,sourceTiles,photoColIdxs.indexOf(c),m,null,'Scroll to browse more photos'));
        }
      }
      gallery.appendChild(frag);
      measure();

      requestAnimationFrame(function(){
        requestAnimationFrame(function(){
          gallery.classList.add('is-ready');
        });
      });
    }

    function applyResponsive(){
      var n=computeCols(),gap=computeGap();
      gallery.style.setProperty('--cols',n);
      gallery.style.setProperty('--gap',gap+'px');
      if(n!==currentColCount)buildColumns(n);
    }
    applyResponsive();

    window.addEventListener('load',measure);
    var resizeTimer;
    window.addEventListener('resize',function(){
      clearTimeout(resizeTimer);
      resizeTimer=setTimeout(applyResponsive,150);
    });

    function render(dt){
      var now=performance.now();
      cols.forEach(function(c){
        if(!c.height)return;
        if(!c.dragging&&now>=c.pausedUntil&&!reduceMotion){
          var effSeconds=c.duration/speed;
          c.offset+=c.dir*(c.height/(effSeconds*1000))*dt;
        }
        c.offset=((c.offset%c.height)+c.height)%c.height;
        c.el.style.transform='translate3d(0,'+(-c.offset)+'px,0)';
      });
    }
    var lastT=null;
    function loop(t){
      if(lastT==null)lastT=t;
      render(t-lastT);
      lastT=t;
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);

    /* ── Lightbox ── */
    var photosScript=root.querySelector('script[data-csw-photos]');
    var photos=[];
    if(photosScript){
      try{photos=JSON.parse(photosScript.textContent)}catch(e){photos=[]}
    }
    if(!photos.length)return;

    var lightbox=root.querySelector('.csw-lightbox');
    if(!lightbox)return;
    var lbImg=lightbox.querySelector('img'),
        lbCounter=lightbox.querySelector('.csw-lb-counter'),
        lbClose=lightbox.querySelector('.csw-lb-close'),
        lbPrev=lightbox.querySelector('.csw-lb-prev'),
        lbNext=lightbox.querySelector('.csw-lb-next');

    var current=-1,lastFocused=null,untrap=null;

    function trapFocus(container){
      var focusable=container.querySelectorAll('button,a[href],[tabindex]:not([tabindex="-1"])');
      var first=focusable[0],last=focusable[focusable.length-1];
      function handler(e){
        if(e.key!=='Tab'||!focusable.length)return;
        if(e.shiftKey){if(document.activeElement===first){e.preventDefault();last.focus()}}
        else{if(document.activeElement===last){e.preventDefault();first.focus()}}
      }
      container.addEventListener('keydown',handler);
      return function(){container.removeEventListener('keydown',handler)};
    }

    function show(i){
      var n=photos.length;
      current=((i%n)+n)%n;
      var src=photos[current];
      if(!src)return;
      lbImg.src=src;
      if(lbCounter)lbCounter.textContent=(current+1)+' / '+n;
      lightbox.classList.add('is-open');
      lastFocused=document.activeElement;
      if(lbClose)lbClose.focus();
      untrap=trapFocus(lightbox);
    }

    function close(){
      current=-1;
      lightbox.classList.remove('is-open');
      lbImg.src='';
      if(untrap){untrap();untrap=null}
      if(lastFocused&&lastFocused.focus)lastFocused.focus();
    }

    function step(d){show(current+d)}

    gallery.addEventListener('click',function(e){
      var tile=e.target.closest('[data-i]');
      if(!tile)return;
      var colEl=tile.closest('.csw-col');
      var state=colEl&&colEl._cswState;
      if(state&&state.suppressClick){
        state.suppressClick=false;
        e.preventDefault();
        e.stopPropagation();
        return;
      }
      var idx=parseInt(tile.getAttribute('data-i'),10);
      if(!isNaN(idx))show(idx);
    });

    if(lbClose)lbClose.addEventListener('click',close);
    if(lbPrev)lbPrev.addEventListener('click',function(){step(-1)});
    if(lbNext)lbNext.addEventListener('click',function(){step(1)});
    lightbox.addEventListener('click',function(e){if(e.target===lightbox)close()});

    window.addEventListener('keydown',function(e){
      if(current<0)return;
      if(e.key==='Escape')close();
      else if(e.key==='ArrowRight')step(1);
      else if(e.key==='ArrowLeft')step(-1);
    });
  });
})();
